import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalService } from '../../../core/services/portal.service';
import { BotState } from '../../../core/store/bot/bot.state';
import { Client } from '../../../features/bot/modules/bot-crm/store';
import { ChatApiResponse, ChatMessageBody, Suggestion } from '../store';

@Injectable()
export class ChatService {
  @SelectSnapshot(BotState.getBotId)
  botId!: string;

  constructor(private http: HttpClient) {}

  getMessages(client: Client, offset: number): Observable<any> {
    const params = {
      limit: '30',
      offset: offset.toString(),
      detailed: '1',
    };
    return this.http.get<ChatApiResponse>(
      PortalService.ApiUrl +
        '/client/messages/' +
        this.botId +
        '/' +
        client.client_id,
      { params }
    );
  }

  sendMessage(clientId: string, message: ChatMessageBody): Observable<any> {
    return this.http.post(
      `${PortalService.ApiUrl}/message/send/${clientId}`,
      message
    );
  }

  sendFile(file: File, type: string, clientId: string): void {
    console.log('sendFile');
    this.uploadFile(file, type).subscribe((res) => {
      if (res.status) {
        const message: ChatMessageBody = {
          type,
          content: {
            url: res.url,
            name: res.name,
          },
        };
        this.sendMessage(clientId, message).subscribe();
      }
    });
  }

  private uploadFile(
    file: File,
    type: string
  ): Observable<{ name: string; status: boolean; url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ name: string; status: boolean; url: string }>(
      `${PortalService.ApiUrl}/message/attachment/${type}`,
      formData
    );
  }

  runScenario(scenarioId: string, clientId: string): void {
    this.http
      .post(`${PortalService.ApiUrl}/client/${clientId}/run/scenario`, {
        scenario_id: scenarioId,
      })
      .subscribe();
  }

  changeDialogMode(client: Client): Observable<string> {
    const clientId = client.client_id;
    const curentMode = client.mode;
    const mode = curentMode === 'auto' ? 'manual' : 'auto';

    const body = {
      bot_id: this.botId,
      mode,
    };

    return this.http
      .post<{ status: boolean }>(
        PortalService.ApiUrl + '/client/mode/' + clientId,
        body
      )
      .pipe(
        map((res: { status: boolean }) => {
          if (res.status) {
            return mode;
          } else {
            return curentMode;
          }
        })
      );
  }

  getSuggestions(keyword: string): Observable<Suggestion[]> {
    const params = {
      type: 'response',
      keyword,
    };
    return this.http
      .get<{ status: boolean; suggestions: Suggestion[] }>(
        `${PortalService.ApiUrl}/widget/suggestions/${this.botId}`,
        { params }
      )
      .pipe(
        map((res) => {
          if (res.status) {
            return res.suggestions;
          } else {
            return [];
          }
        })
      );
  }
}
